import { Slider } from '@/components/Slider';
import { SlideShowTheme } from '@/components/SlideShow/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const SlideShow = GenericSlot({ as: Slider, theme: SlideShowTheme });
